export default "__VITE_ASSET__D4$FU1dl__"